module.exports = __webpack_public_path__ + "img/blue_neon.5d1b71f.svg";